export default __webpack_public_path__ + "static/media/GR.2793735b.svg";